import { Row } from 'antd';
import React from 'react';
import { Col } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import Text from 'v3/components/Text';
import theme from 'v3/theme';
import { formatCurrency } from 'v3/utils/formatter';

export function ExtraFieldShowRow({
  label,
  percentageValue = null,
  value,
  dollarValue,
  showToDriver = false,
}) {
  return (
    <Row>
      <Col xs={12} md={2}>
        <Text type="regular" color="dark" as="p" weight={500}>
          {label}
        </Text>
      </Col>
      {percentageValue ? (
        <Col xs={12} md={1}>
          <Text type="regular" color="gray" as="p">
            {`${percentageValue}%`}
          </Text>
        </Col>
      ) : (
        <Col md={1} />
      )}
      <Col xs={12} md={3}>
        <Text type="regular" color="gray" as="p">
          {formatCurrency(value, 'R$')}
        </Text>
      </Col>
      <Col xs={12} md={3}>
        <Text type="regular" color="gray" as="p">
          {formatCurrency(dollarValue, 'USD', '$', 4)}
        </Text>
      </Col>
      <Col xs={12} md={3}>
        <button
          type="button"
          disabled
          style={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'default',
            background: 'transparent',
          }}
        >
          {showToDriver ? (
            <FaEye color={theme.colors.dark_blue} title="Motorista poderá visualizar este valor" />
          ) : (
            <FaEyeSlash color={theme.colors.dark_blue} title="Motorista não visualiza este valor" />
          )}
        </button>
      </Col>
    </Row>
  );
}
